import type { Dictionary } from '~/renderer/utils/types';

export enum ENVIRONMENTS {
  LOCALHOST = 'localhost',
  BUNDLED = 'bundled',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export enum HUB_BACKEND_ENVIRONMENTS {
  LOCALHOST = 'localhost',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export const HubBackendEnvironmentUrls = {
  [HUB_BACKEND_ENVIRONMENTS.LOCALHOST]: process.env.HUB_BACKEND_URL,
  [HUB_BACKEND_ENVIRONMENTS.STAGING]: 'https://hub-backend.lightspeedappstg.com/',
  [HUB_BACKEND_ENVIRONMENTS.PRODUCTION]: 'https://hub-backend.lightspeedapp.com/',
};

export interface License {
  isSigned: boolean;
  version: string;
}

type Environment = {
  url: string;
};

type EnvironmentConfigs = Partial<Dictionary<ENVIRONMENTS, Environment>>;
type HubBackendEnvironmentConfigs = Partial<Dictionary<HUB_BACKEND_ENVIRONMENTS, Environment>>;

export const isDevelopmentEnvironment = () => process.env.NODE_ENV === ENVIRONMENTS.DEVELOPMENT;
export const isProductionEnvironment = () => process.env.NODE_ENV === ENVIRONMENTS.PRODUCTION;

export const environments: EnvironmentConfigs = {
  ...(isDevelopmentEnvironment()
    ? {
        [ENVIRONMENTS.LOCALHOST]: {
          url: `${process.env.BASE_APP_URL}webpack/`,
        },
      }
    : {}),
  [ENVIRONMENTS.BUNDLED]: {
    url: `file://${__dirname}/`,
  },
};

export const hubBackendEnvironments: HubBackendEnvironmentConfigs = {
  ...(isDevelopmentEnvironment()
    ? {
        [HUB_BACKEND_ENVIRONMENTS.LOCALHOST]: {
          url: HubBackendEnvironmentUrls[HUB_BACKEND_ENVIRONMENTS.LOCALHOST] as string,
        },
      }
    : {}),
  [HUB_BACKEND_ENVIRONMENTS.STAGING]: {
    url: HubBackendEnvironmentUrls[HUB_BACKEND_ENVIRONMENTS.STAGING],
  },
  [HUB_BACKEND_ENVIRONMENTS.PRODUCTION]: {
    url: HubBackendEnvironmentUrls[HUB_BACKEND_ENVIRONMENTS.PRODUCTION],
  },
};
